import React from "react";
import styled from "styled-components";
import Text from "@ui-kit/form/text";

interface IProps {
  range: { gt: string; lt: string };
  onChangeRange: (range: { gt: string; lt: string }) => void;
  className?: string;
}

const Inputs = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const FilterbarPanelsMinMax = ({ range, onChangeRange, className }: IProps) => (
  <div className={className}>
    <Inputs>
      <div style={{ marginRight: 6 }}>
        <Text
          value={range.gt}
          placeholder="min"
          onChange={(value) => onChangeRange({ ...range, gt: value })}
        />
      </div>
      <div style={{ marginLeft: 6 }}>
        <Text
          value={range.lt}
          placeholder="max"
          onChange={(value) => onChangeRange({ ...range, lt: value })}
        />
      </div>
    </Inputs>
  </div>
);

export default FilterbarPanelsMinMax;
